import { useState, useEffect, useMemo } from "react";
import { userClientData } from "../services/iqApiV2";

export function useUserWiseProductList(user) {
  const [userWiseProductList, setUserWiseProductList] = useState([]);

  const dependencies = useMemo(
    () => [user?.id, user?.company_name, user?.role_key],
    [user?.id, user?.company_name, user?.role_key]
  );

  useEffect(() => {
    async function fetchProducts() {
      try {
        const userId = user?.id;
        const clientName = user?.company_name;
        const currentRole = user?.role_key || "CLIENT";

        if (!userId || !clientName) {
          console.warn("Missing userId or clientName");
          setUserWiseProductList([]);
          return;
        }

        const data = await userClientData(userId, clientName, currentRole);

        if (Array.isArray(data?.products)) {
          const seen = new Set();
          const products = data.products
            .filter(item => {
              if (seen.has(item?._id)) return false;
              seen.add(item?._id);
              return true;
            })
            .map(item => ({
              _id: item?._id,
              name: item?.product_name,
              description: item?.product_description,
            }));

          setUserWiseProductList(products);
        } else {
          console.warn("Unexpected product structure:", data);
          setUserWiseProductList([]);
        }
      } catch (err) {
        console.error("Failed to fetch client data:", err);
        setUserWiseProductList([]);
      }
    }

    fetchProducts();
  }, dependencies);

  return userWiseProductList;
}
